import { createFileRoute } from "@tanstack/react-router";
import { OnboardingTemplate } from "~/features/onboarding/OnboardingTemplate";

export const Route = createFileRoute("/_authenticated/onboarding/")({
  component: OnboardingTemplate,
});
